/**
 * Push notification model
 */
export default class PushNotification {
  /**
   * Notification type
   *
   * @type {string}
   * @private
   */

  /**
   * Notification payload data
   *
   * @type {object}
   * @private
   */

  /**
   * @type {null}
   * @private
   */

  /**
   * Remove notification from status bar
   *
   * @type {null|function}
   * @private
   */

  /**
   * @type {boolean}
   * @private
   */

  /**
   * @type {boolean}
   * @private
   */

  /**
   * PushNotification constructor
   *
   * @param {object} notification
   * @param {object} params
   *
   * @return {undefined}
   */
  constructor(notification, _params = {}) {
    this._type = 'none';
    this._data = {};
    this._openIdentifier = null;
    this._completionCallback = null;
    this._androidIsForeground = false;
    this._isInitNotification = false;

    this.getType = () => {
      return this._type;
    };

    this.getData = () => {
      return this._data;
    };

    this.isOpened = () => {
      return this._openIdentifier !== null;
    };

    this.isInit = () => {
      return this._isInitNotification;
    };

    this.isAndroidForeground = () => {
      return this._androidIsForeground;
    };

    this.getOpenIdentifier = () => {
      return this._openIdentifier;
    };

    this.runComplete = params => {
      if (this._completionCallback) {
        this._completionCallback(params);
      }
    };

    const data = typeof notification.getData === 'function' && notification.getData() || notification && notification.data || {};
    const {
      action,
      completion,
      isForeground,
      isInit
    } = _params;
    this._data = data;
    this._type = data && data.type;

    if (action && action.identifier) {
      this._openIdentifier = action.identifier;
    }

    if (completion) {
      this._completionCallback = completion;
    }

    if (isForeground) {
      this._androidIsForeground = isForeground;
    }

    if (isInit) {
      this._isInitNotification = isInit;
    }
  }
  /**
   * Get notification type
   *
   * @see NotificationTypes
   *
   * @return {string}
   */


}